import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PubnubDetailsComponent } from './components/pubnub-details/pubnub-details.component';
import { PubnubMessageComponent } from './components/pubnub-message/pubnub-message.component';
import { PubnubPresenceComponent } from './components/pubnub-presence/pubnub-presence.component';
import { PubnubStatusComponent } from './components/pubnub-status/pubnub-status.component';
import { PubnubSubscribedChannelsComponent } from './components/pubnub-subscribed-channels/pubnub-subscribed-channels.component';

@NgModule({
  declarations: [
    PubnubStatusComponent,
    PubnubMessageComponent,
    PubnubPresenceComponent,
    PubnubSubscribedChannelsComponent,
    PubnubDetailsComponent,
  ],
  imports: [CommonModule],
  exports: [
    PubnubStatusComponent,
    PubnubMessageComponent,
    PubnubPresenceComponent,
    PubnubSubscribedChannelsComponent,
    PubnubDetailsComponent,
  ],
})
export class AmgPubnubModule {}
